import { Button, Paper, Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import OneSelect from "../../OneSelect/OneSelect"
import OneTextArea from "../../OneTextArea/OneTextArea"
import { useContext, useEffect, useState } from "react"
import { CondominiosContext } from "../../../Providers/CondominiosContext/CondominiosContext"
import { WebSocketContext } from "../../../Providers/WebSocket/WebSocketContext"
import { statusOrdemServico, tiposOrdemServico } from "../../../Utils/optionsSelects"
import OneInput from "../../OneInput/OneInput"
import { OneSwitch } from "../../OneSwitch/OneSwitch"
import { showNotify } from "../../../Utils/Utils"
import { formGroupInput, formGroupSx, lineSx, newSx, paperSx } from './CriarEditarOrdemServicoSx'
import OneSelectPrioridade from '../../OneSelectPrioridade/OneSelectPrioridade'
import { prioridades } from '../../../Utils/optionsEventos'
import { OrdemServicoContext } from '../../../Providers/OrdemServicoContext/OrdemServicoContext'
import ComboBox from '../../ComboBox/ComboBox'
import { EventosContext } from "../../../Providers/EventosContext/EventosContext"
import moment from "moment"
import { UserContext } from "../../../Providers/UserContext/UserContex"
import { RondaContext } from '../../../Providers/RondaContext/RondaContext'

const CriarEditarOrdemServico = () => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { condominios, activeCond } = useContext(CondominiosContext)
    const { idEdit, setIdEdit, buscarOrdensServico } = useContext(OrdemServicoContext)
    const { eventoSelecionado, finalizarEvento } = useContext(EventosContext)
    const { user } = useContext(UserContext)
    const { respostaLog } = useContext(RondaContext)

    const [optionsTecnicos, setOptionsTecnicos] = useState([{ id: 0, nome: 'Selecionar' }])
    const [formData, setFormData] = useState({})
    const [initialData, setInitialData] = useState({})
    const [loading, setLoading] = useState(false)
    const [agendar, setAgendar] = useState()
    const [listTipoOcorrencias, setListTipoOcorrencias] = useState([{ id: 0, descricao: 'Selecionar' }])
    const [listaEntrada, setListaEntrada] = useState([])

    useEffect(() => {
        addRoute('buscarListagens#ordemServico', (msg) => {
            const { status, message } = msg.data

            if (status === 'error' || !status) {
                showNotify('danger', message)
                return
            }

            let tecnicos = msg.data?.listagens?.tecnico
            tecnicos.unshift({ id: 0, nome: 'Selecionar', nivel: 7 })
            setOptionsTecnicos(tecnicos)
        })

        sendWs('buscarListagens#ordemServico', {
            listagens: {
                tecnico: ["id", "nome", "nivel", "ativo"]
            }
        })

        if (eventoSelecionado?.evento == 'EVOS') {
            setIdEdit(eventoSelecionado.serial)
        }
    }, [])

    useEffect(() => {
        const event = {
            target: {
                name: "motivo",
                value: respostaLog
            }
        }

        handleChange(event)
        setInitialData(prevData => ({
            ...prevData,
            motivo: respostaLog
        }))
    }, [respostaLog])
    // listagem de entradas
    useEffect(() => {
        sendWs("listaEntradas", { id_central: activeCond.id_central || formData.id_central })
        addRoute("listaEntradas", getListaEntrada)
    }, [activeCond.id_central, formData.id_central])

    // atualiza o campo causa, caso observacao seja alterado
    useEffect(() => {
        setFormData(prev => ({
            ...prev,
            causa: formData.observacao
        }));
    }, [formData.observacao]);

    // data/hora do fechamento
    useEffect(() => {
        if (formData.status == 3) {
            const currentDate = moment().format('YYYY-MM-DD HH:mm');
            setFormData(prev => ({
                ...prev,
                data_fechamento: currentDate
        }));
    }
    }, [formData.status]);

    const getListaEntrada = (msg) => {
        const arrayListaEntradas = msg.data.listaEntradas
        const novaListaEntrada = arrayListaEntradas.map((entrada) => ({
            descricao: entrada.descricao,
            id_entrada: entrada.id
        }))
        if (novaListaEntrada.length > 0) {
            setListaEntrada(novaListaEntrada)
        }
    }

    // listagem de tipo ocorrencia
    useEffect(() => {
        addRoute("getTiposOcorrencias", getWsResponse)
        sendWs("getTiposOcorrencias")
    }, [])

    const getWsResponse = (msg) => {
        let tiposOcorrencias = msg.data.retorno.map((tipo) => (
            { id: tipo.id, descricao: tipo.descricao }
        ))
        setListTipoOcorrencias((prevTags) => {
            const combinados = [...prevTags, ...tiposOcorrencias]
            const unicosPorId = Array.from(
                new Map(combinados.map(item => [item.id, item])).values()
            )
            return unicosPorId
        })
    }

    const optionsCondominios = condominios.map((condominio) => {
        return { nome: `${condominio.id_central}-${condominio.nome} `, id_central: condominio.id_central }
    })

    const handleChange = (event) => {
        if (event.target.value !== undefined) {
            if (event.target.type == 'checkbox') {
                setFormData({ ...formData, [event.target.name]: event.target.checked })
            } else {
                setFormData({ ...formData, [event.target.name]: event.target.value })
            }
        }
    }

    const handleSubmit = () => {
        /* if (Object.keys(initialData).length > 0) {
            let hasUpdated = false

            for (const campo in formData) {
                if (initialData[campo] !== formData[campo]) {
                    hasUpdated = true
                    break
                }
            }

            if (!hasUpdated) {
                showNotify('warning', 'Nenhuma alteração realizada')
                return
            }
        } */

        if (formData.hasOwnProperty('tecnico') && !formData.tecnico) {
            delete formData.tecnico
        }

        const tecnicoId = formData.tecnico || initialData.tecnico
        if (tecnicoId) {
            const tecnicoSelecionado = optionsTecnicos.find(t => t.id === tecnicoId)
            if (tecnicoSelecionado && !tecnicoSelecionado.ativo) {
                showNotify('warning', 'Técnico inativo')
                return
            }
        }

        if (formData.hasOwnProperty('data_agendamento')) {
            if (formData.hora_agendamento) {
                formData.data_agendamento = `${formData.data_agendamento} ${formData.hora_agendamento}`
            } else {
                formData.data_agendamento = `${formData.data_agendamento} 00:00`
            }
            delete formData.hora_agendamento
        } else {
            if (formData.hasOwnProperty('hora_agendamento') && initialData.data_agendamento) {
                formData.data_agendamento = `${initialData.data_agendamento} ${formData.hora_agendamento}`
                delete formData.hora_agendamento
            }
        }

        if (formData.hasOwnProperty('agendar') && !formData.agendar) {
            formData.data_agendamento = null
        }

        if (initialData.id_tipo_ocorrencia && formData.id_tipo_ocorrencia == undefined) {
            formData.id_tipo_ocorrencia = initialData.id_tipo_ocorrencia
        }

        if (formData.status == 3 && (formData.id_tipo_ocorrencia == undefined || formData.id_tipo_ocorrencia == 0)) {
            showNotify("warning", "Selecione um tipo para esta ordem de serviço")
            return
        }

        if (initialData.id_tipo_ocorrencia && formData.id_tipo_ocorrencia == undefined) {
            formData.id_tipo_ocorrencia = initialData.id_tipo_ocorrencia
        }

        if (formData.status == 3 && (formData.id_tipo_ocorrencia == undefined || formData.id_tipo_ocorrencia == 0)) {
            showNotify("warning", "Selecione um tipo para esta ordem de serviço")
            return
        }

        if (formData.hasOwnProperty('tecnico')) {
            formData.id_revenda = condominios[0].id_revenda_nuvem
            formData.id_condominio = condominios[0].id_condominio_nuvem
            formData.nome_condominio = condominios[0].apelido
        }

        if (idEdit) {
            if (formData.hasOwnProperty('id_central') && !formData.id_central) {
                showNotify("warning", "Selecione um condomínio")
                return
            }

            if (formData.hasOwnProperty('solucao') && !formData.solucao) {
                showNotify("warning", "É necessário preencher a solução")
                return
            }

            if (formData.hasOwnProperty('agendar') && formData.agendar && !formData.data_agendamento) {
                showNotify("warning", "É necessário preencher a data ou desativar o agendamento da ordem de serviço")
                return
            }

            setLoading(true)
            formData.id = idEdit
            sendWs('editarOrdemServico', { ordemServico: formData })

            if (eventoSelecionado && eventoSelecionado.evento == 'EVOS') {
                const id = eventoSelecionado.id
                const observacao = formData.solucao
                const id_hashtag = eventoSelecionado.id_hashtag

                if (!id) {
                    return
                }
                finalizarEvento({ id, observacao, id_hashtag, notificacoes: '' })
            }
            return
        }

        if (!formData.data_agendamento && formData.hora_agendamento) {
            showNotify("warning", "É necessário preencher uma data")
            return
        }

        if (!formData.id_central) {
            if (activeCond.id_central) {
                formData.id_central = activeCond.id_central
            } else {
                showNotify("warning", "Selecione um condomínio")
                return
            }
        }

        if (!formData.motivo) {
            showNotify("warning", "É necessário preencher o motivo")
            return
        }

        if (formData.agendar && !formData.data_agendamento) {
            showNotify("warning", "É necessário preencher a data ou desativar o agendamento da ordem de serviço")
            return
        }

        setLoading(true)
        sendWs('criarOrdemServico', { ordemServico: formData })

        if (eventoSelecionado && eventoSelecionado.evento == 'ONRV') {
            const id = eventoSelecionado.id
            const observacao = formData.motivo
            const id_hashtag = eventoSelecionado.id_hashtag

            if (!id) {
                return
            }
            setTimeout(() => {
                finalizarEvento({ id, observacao, id_hashtag, notificacoes: '' })
            }, 500)
        }
    }

    const getCriarOrdemServico = (msg) => {
        const { status, message } = msg.data

        if (status == 'error' || !status) {
            showNotify("error", message)
            setLoading(false)
            return
        }

        showNotify("success", "Ordem de serviço criada com sucesso")

        setFormData({})
        setInitialData({})
        buscarOrdensServico()
        setLoading(false)
        setAgendar(false)
    }

    const getEditarOrdemServico = (msg) => {
        const { status, message } = msg.data

        if (status === 'error' || !status) {
            showNotify('error', message)
            return
        }

        showNotify("success", "Ordem de serviço editada com sucesso")

        setFormData({})
        setInitialData({})
        setIdEdit(null)
        buscarOrdensServico()
        setLoading(false)
    }

    addRoute("criarOrdemServico", getCriarOrdemServico)
    addRoute("editarOrdemServico", getEditarOrdemServico)

    useEffect(() => {
        setLoading(true)
        if (idEdit) {
            addRoute("buscarOrdemServico#criarEditarOrdemServico", (msg) => {
                const { status, message, ordemServico } = msg.data

                if (status === 'error' || !status) {
                    showNotify('error', message)
                    return
                }

                setListaEntrada([])
                setFormData({})

                if (ordemServico.data_agendamento) {
                    [ordemServico.data_agendamento, ordemServico.hora_agendamento] = ordemServico.data_agendamento.split(" ")
                }

                sendWs("listaEntradas", { id_central: ordemServico.id_central })
                addRoute("listaEntradas", getListaEntrada)

                setInitialData(ordemServico)
                setAgendar(ordemServico.agendar)

                if (ordemServico.tecnico && ordemServico.nomeTecnico) {
                    setOptionsTecnicos(prev => {
                        const exists = prev.some(t => t.id === ordemServico.tecnico)
                        if (exists) return prev
                        return [...prev, { id: ordemServico.tecnico, nome: ordemServico.nomeTecnico, nivel: 0 }]
                    })
                }

                setLoading(false)
            })
            sendWs("buscarOrdemServico#criarEditarOrdemServico", { id: idEdit })
        } else {
            setLoading(false)
        }
    }, [idEdit])

    const handleAgendarChange = (e) => {
        handleChange(e)
        setAgendar(!agendar)
    }

    const handleLimpaTela = () => {
        setInitialData({})
        setFormData({})
        setAgendar(false)
        setLoading(true)
        setIdEdit()
        setOptionsTecnicos([{ id: 0, nome: 'Selecionar' }])
        sendWs('buscarListagens#ordemServico', {
            listagens: {
                tecnico: ["id", "nome", "nivel", "ativo"]
            }
        })
    }

    const tempoEditar = (data_cadastro) => {
        const dataCriacao = moment(data_cadastro)
        const agora = moment()
        const diferencaMinutos = agora.diff(dataCriacao, 'minutes')
        return diferencaMinutos < 15
    }

    const isDisabled = () => {
        return idEdit == undefined ? true : (user.id == initialData.usuario_cadastro && tempoEditar(initialData.data_cadastro))
    }

    const entradaDisabled = () => {
        return !(formData.id_central !== undefined || activeCond.id_central !== '' || initialData.id_central !== undefined)
    }

    const editaPeloStatus = () => {
        return initialData.status == 3 || initialData.status == 4
    }

    return (
        <Paper sx={paperSx}>
            {!loading &&
                <>
                    <Grid sx={lineSx}>
                        <Grid sx={formGroupSx} xs={4} >
                            <Typography sx={{ ...newSx.label, width: { lg: '50%', xl: '28%' } }} >Categoria: </Typography>
                            <Grid sx={formGroupInput}>
                                <OneSelect
                                    newSx={newSx.input}
                                    options={tiposOrdemServico.getAll()}
                                    defaultValue={initialData.tipo || tiposOrdemServico.getOne(1)}
                                    name="tipo"
                                    onChange={handleChange}
                                    disabled={editaPeloStatus()}
                                />
                            </Grid>
                        </Grid>
                        <Grid sx={formGroupSx} xs>
                            <Typography sx={newSx.label} >Cond./Empresa: </Typography>
                            <Grid sx={formGroupInput}>
                                <ComboBox
                                    newSx={newSx.input}
                                    options={optionsCondominios}
                                    value={initialData.id_central || formData.id_central || activeCond.id_central}
                                    label="nome"
                                    valor="id_central"
                                    name="id_central"
                                    onChange={handleChange}
                                    todos
                                    disabled={!isDisabled() || editaPeloStatus()}
                                />
                            </Grid>
                        </Grid>
                        <Grid sx={formGroupSx} xs>
                            <Typography sx={newSx.label} >Entradas: </Typography>
                            <Grid sx={formGroupInput}>
                                <ComboBox
                                    newSx={newSx.input}
                                    options={listaEntrada}
                                    defaultValue={initialData.id_entrada || 0}
                                    label="descricao"
                                    valor="id_entrada"
                                    name="id_entrada"
                                    onChange={handleChange}
                                    disabled={entradaDisabled() || editaPeloStatus()}
                                />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid sx={lineSx}>

                        <Grid sx={formGroupSx} xs={2.6}>
                            <Typography sx={{ ...newSx.label, width: { lg: '100%', xl: '51%' } }} >Status: </Typography>
                            <Grid sx={formGroupInput}>
                                <OneSelect
                                    newSx={{ ...newSx.input, width: '100%' }}
                                    options={statusOrdemServico.getAllSemCancelado()}
                                    defaultValue={initialData.status || statusOrdemServico.getOne(1).id}
                                    name="status"
                                    onChange={handleChange}
                                    disabled={editaPeloStatus()}
                                />
                            </Grid>
                        </Grid>
                        <Grid sx={formGroupSx} xs={2}>
                            <OneSwitch
                                defaultValue={initialData.agendar}
                                name="agendar"
                                onChange={handleAgendarChange}
                                disabled={editaPeloStatus()}
                            />
                            <Typography sx={newSx.label} >Agendar OS</Typography>
                        </Grid>

                        <Grid sx={formGroupSx} xs={2.2}>
                            <Typography sx={newSx.label} >Data: </Typography>
                            <Grid sx={formGroupInput}>
                                <OneInput
                                    newSx={newSx.input}
                                    defaultValue={initialData.data_agendamento}
                                    type="date"
                                    name="data_agendamento"
                                    onChange={handleChange}
                                    disabled={!agendar || editaPeloStatus()}
                                />
                            </Grid>
                        </Grid>

                        <Grid sx={formGroupSx} xs>
                            <Typography sx={newSx.label} >Hora: </Typography>
                            <Grid sx={formGroupInput}>
                                <OneInput
                                    newSx={newSx.input}
                                    defaultValue={initialData.hora_agendamento}
                                    type="time"
                                    name="hora_agendamento"
                                    onChange={handleChange}
                                    disabled={!agendar || editaPeloStatus()}
                                />
                            </Grid>
                        </Grid>

                        <Grid sx={formGroupSx} xs={2.5}>
                            <Typography sx={newSx.label} >Prioridade: </Typography>
                            <Grid sx={formGroupInput}>
                                <OneSelectPrioridade
                                    sx={newSx.input}
                                    onChange={handleChange}
                                    options={prioridades}
                                    defaultValue={initialData?.prioridade}
                                    name={"prioridade"}
                                    disabled={editaPeloStatus()}
                                />
                            </Grid>
                        </Grid>

                    </Grid>

                    <Grid sx={lineSx}>
                        <Grid sx={formGroupSx} xs>
                            <Typography sx={{ ...newSx.label, width: { lg: '12%', xl: '8%' } }} >Motivo: </Typography>
                            <OneTextArea
                                defaultValue={initialData.motivo}
                                name="motivo"
                                onChange={handleChange}
                                // readOnly={initialData.usuario_cadastro == -1}
                                disabled={!isDisabled()}
                            />
                        </Grid>
                    </Grid>

                    <Grid sx={lineSx}>
                        <Grid sx={formGroupSx} xs>
                            <Typography sx={{ ...newSx.label, width: { lg: '12%', xl: '8%' } }} >Descrição: </Typography>
                            <OneTextArea
                                defaultValue={initialData.observacao}
                                name="observacao"
                                onChange={handleChange}
                                // readOnly={initialData.usuario_cadastro == -1}
                                disabled={!isDisabled()}
                            />
                        </Grid>
                    </Grid>

                    <Grid sx={lineSx}>
                        <Grid sx={formGroupSx} xs>
                            <Typography sx={{ ...newSx.label, width: { lg: '12%', xl: '8%' } }} >Solução: </Typography>
                            <OneTextArea
                                defaultValue={initialData.solucao}
                                name="solucao"
                                onChange={handleChange}
                                disabled={editaPeloStatus()}
                            />
                        </Grid>
                    </Grid>

                    <Grid sx={lineSx}>
                        <Grid sx={{ ...formGroupSx, gap: '30px' }} xs>
                            <Grid sx={formGroupSx} xs>
                                <Typography sx={{ ...newSx.label, width: { lg: '70%', xl: '35%' } }} >Técnico: </Typography>
                                <Grid sx={formGroupInput}>
                                    <ComboBox
                                        newSx={newSx.input}
                                        options={optionsTecnicos}
                                        defaultValue={initialData.tecnico || optionsTecnicos[0].id}
                                        name="tecnico"
                                        label="nome"
                                        valor="id"
                                        onChange={handleChange}
                                        disabled={editaPeloStatus()}
                                    />
                                </Grid>
                            </Grid>
                            <Grid sx={formGroupSx} xs>
                                <Typography sx={{ ...newSx.label, width: '70%' }} >Tipo: </Typography>
                                <Grid sx={formGroupInput}>
                                    <ComboBox
                                        newSx={newSx.input}
                                        options={listTipoOcorrencias}
                                        defaultValue={initialData.id_tipo_ocorrencia || listTipoOcorrencias[0].id}
                                        label="descricao"
                                        name="id_tipo_ocorrencia"
                                        valor="id"
                                        onChange={handleChange}
                                        disabled={editaPeloStatus()}
                                    />
                                </Grid>
                            </Grid>
                            {(eventoSelecionado.evento == 'EVOS' && eventoSelecionado.usuario !== undefined && eventoSelecionado.usuario !== '')
                                ? <Grid sx={formGroupSx} xs>
                                    <Typography sx={newSx.label} >Sindico: </Typography>
                                    <Grid sx={formGroupInput}>
                                        <OneInput
                                            newSx={newSx.input}
                                            defaultValue={eventoSelecionado.usuario}
                                            readOnly
                                            disabled={editaPeloStatus()}
                                        />
                                    </Grid>
                                </Grid>
                                : ''
                            }
                            <Grid sx={formGroupSx} xs>
                                {/* <OneSwitch
                                defaultValue={initialData.notificar_tecnico_whatsapp}
                                name="notificar_tecnico_whatsapp"
                                onChange={handleChange}
                            />
                            <Typography sx={newSx.label} >Notificar Técnico Whatsapp</Typography> */}
                            </Grid>
                        </Grid>
                        {idEdit ? <Button variant="contained" color="one_primary" sx={{ height: { lg: '20px', xl: '30px' }, fontSize: { lg: '11px', xl: '14px' } }} onClick={handleLimpaTela} >Novo</Button> : ''}
                        <Button variant="contained" color="one_primary" sx={{ height: { lg: '20px', xl: '30px' }, fontSize: { lg: '11px', xl: '14px' } }} onClick={handleSubmit} >Salvar</Button>
                    </Grid>
                </>
            }
        </Paper>
    )
}

export default CriarEditarOrdemServico
